import { List as AntList, Row, Space } from 'antd'
import ExtendBulkForm from 'app/components/Core/ExtendLineItemRequest/BulkForm'
import { subItemsWithFreeAttachment } from 'app/components/Core/LineItem/helpers'
import LineItemBaseItem from 'app/components/Core/LineItem/Item/Base'
import VacantBulkForm from 'app/components/Core/LineItemVacant/BulkForm'
import FreeSubItemList from 'app/components/Core/MachineGroup/FreeSubItemList'
import { InteractionType } from 'app/components/Core/MachineGroup/MachineInteraction/Steps'
import KList from 'app/components/Modules/List/KList'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

const lineItemsWithFreeAttachment = (lineItems: ILineItem[]) =>
  lineItems.flatMap((lineItem: ILineItem) => [lineItem, ...subItemsWithFreeAttachment(lineItem)])

type Props = {
  selectedItems: ILineItem[]
  interactionType: InteractionType
}

const Form: React.FC<Props> = ({ selectedItems, interactionType }) => {
  const { tRoute } = useTranslation({ scope: 'rental.machine_interaction' })

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24}>
        <KList<ILineItem>
          dataSource={selectedItems}
          displayHeader={true}
          header={<span className="font-weight-bold">{tRoute({ id: 'selected_machines' })}</span>}
          visualRecordType={RecordType.line_item}
          renderItem={(item: ILineItem) => (
            <AntList.Item>
              <Space direction="vertical" size={0}>
                <LineItemBaseItem
                  member={item}
                  props={{ showStatus: true, showCheckupDays: true }}
                />
                <FreeSubItemList lineItem={item} />
              </Space>
            </AntList.Item>
          )}
          itemLayout="vertical"
        />
      </KCol>
      <KCol span={24}>
        <Choose>
          <When condition={interactionType === 'extend'}>
            <ExtendBulkForm props={{ line_items: selectedItems }} />
          </When>
          <Otherwise>
            <VacantBulkForm props={{ line_items: lineItemsWithFreeAttachment(selectedItems) }} />
          </Otherwise>
        </Choose>
      </KCol>
    </Row>
  )
}
export default Form
